import type { StatusType } from '@datadog/browser-logs';

import isBrowser from '@/utils/isBrowser';

import logToDatadogClient from './logToDatadogClient';
import logToDatadogServer from './logToDatadogServer';
import type { LogPayload } from './types';

const logToDatadog = ({
  data = {},
  error,
  level = 'info',
  message,
  module,
}: LogPayload) => {
  const _level: StatusType = error ? 'error' : level;
  const logToDataDogFn = isBrowser() ? logToDatadogClient : logToDatadogServer;

  logToDataDogFn({
    data,
    error,
    level: _level,
    message,
    module,
  });
};

export default logToDatadog;
